






import { Component, Vue } from 'vue-property-decorator';
import SingleRecordDetails from '@/views/SingleRecordDetails.vue';
import { SingleRecordDetailsInterface } from '@/interfaces/SingleRecordDetailsInterface';
import SampleRecordHelper from '@/helpers/SampleRecordHelper';
import { Action } from 'vuex-class';

@Component({
    components: {
        SingleRecordDetails,
    },
})
export default class SampleRecord extends Vue {
    private sampleRecord: null | SingleRecordDetailsInterface = null;
    private sampleProductGroup: null | string = null;
    @Action('user/setActiveProductGroup') private setActiveProductGroup!: (productGroup: string) => void;


    protected mounted() {
        const id = Number(this.$route.params.id);

        if (id) {
            const sampleRecordHelper = new SampleRecordHelper();
            this.sampleRecord = sampleRecordHelper.getSampleRecord(id);
            if (this.sampleRecord) {
                this.sampleProductGroup = this.sampleRecord.prodGroup;
            }

        }
    }

}
